import { AddonAction } from 'models/AddonAction';
import { connect } from 'react-redux';
import type { TradeClientSide } from 'state/addonForm';
import { addonSelector } from 'state/selectors';
import type { AppState } from 'state/state.model';

export interface OwnProps {
  tabId: string;
}

export interface StateProps {
  tradeClientSide: TradeClientSide;
  addonAction?: AddonAction;
}

export type TradeDoneProps = OwnProps & StateProps;

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const tradeClientSide = addonSelector.getTradeClientSide(state, tabId)!;
  const addonAction = addonSelector.getAddonAction(state, tabId);

  return {
    tradeClientSide,
    addonAction,
  };
};

export const connectTradeDone = connect(mapStateToProps);
